import z from "zod";
/**
 * PatrimonioMaquinaEquipSchema
 */


export const PatrimonioMaquinaEquipSchema = z.object({
  idPatrimonioMaquinaEquip: z.number().optional(),
  idPatrimonioCentroCusto: z.number().optional(),
  descricao: z.string().optional(),
  status: z.coerce.number().default(1),
  idChecklistMaquinaEquip: z.number().optional().nullable(),

});


/**
 * PatrimonioMaquinaEquipForm
 */

export type PatrimonioMaquinaEquipForm = z.infer<typeof PatrimonioMaquinaEquipSchema>;

/**
 * initialPatrimonioMaquinaEquipForm
 */

export const initialPatrimonioMaquinaEquipForm: Partial<PatrimonioMaquinaEquipForm> = {
  status: 0,

};